import { SchoolOfficerRoleEnum, UserCategoryEnum } from "@/shared/ModelEnums";
import AdministrationPayerViewModel from "./AdministrationPayerViewModel";
import PaymentSourceModel from "./PaymentSourceModel";
import { UserViewModel } from "./UserModel";

export default class SchoolOfficerViewModel extends UserViewModel {
  schoolOfficerId?: number;

  position: string;

  schoolReference: string = "";
  schoolOfficerRoleCd: SchoolOfficerRoleEnum = SchoolOfficerRoleEnum.SOR_P; //Principal.
  schoolOfficerDeclarationCd: string = "";
  schoolName: string = "";
  comments: string = "";

  paymentSource?: PaymentSourceModel;

  defaultPaymentSource?: PaymentSourceModel;

  // Address:
  // addressLine1: string = "";
  // addressLine2?: string;
  // addressSuburb: string = "";
  // addressPostcode: string = "";
  // australianStateCd: string = "ACT";
  // addressCountry: string = "Australia";

  constructor() {
    super();

    this.userCategoryCd = UserCategoryEnum.UC_S; // School Officer
    this.userStatusCd = "US_A";
    this.position = "";
    this.schoolOfficerDeclarationCd = "SOD_P"; //Pending.
  }
}
